//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { getInviteReward } from '@/api/my.js'
  export default {
    data () {
      return {
        title: '邀请用户',
        list: []
      }
    },
    methods: {
      onClickLeft () {
        this.$router.goBack()
      },
      getList () {
        getInviteReward({
          pageNum: 1,
          pageSize: 10
        }).then(res => {
          if (res.data.total > 10) {
            getInviteReward({
              pageNum: 1,
              pageSize: res.data.total
            }).then(res => {
              this.list = res.data.list
            })
          } else {
            this.list = res.data.list
          }
        })
      }
    },
    created () {
      this.getList()
    }
  }
  


// WEBPACK FOOTER //
// ./src/pages/Mine/user.vue